// extracted by mini-css-extract-plugin
module.exports = {"metadata":"Metadata-metadata-yUSNo Card-card-1iGZk","name":"Metadata-name-3kJ89","section":"Metadata-section-3ACBk"};